import React from 'react'
import PropTypes from 'prop-types'
import './button.css'
import { joinClassList } from '../../components/utilities/utilities.js'

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  asAnchor = true,
  variant = "Button--primary",
  theme = "reversed",
  size = "default",
  text,
  ...props
}) => {
  const buttonClasses = joinClassList([
    'Button',
    `Button--${variant}`,
    theme == 'reversed' ? 'Button--reversed' : '',
    size ? `Button--${size}` : '',
  ])
  return asAnchor ? (
    <a type="button" className={buttonClasses} {...props}>
      {text}
    </a>
  ) : (
    <button type="button" className={buttonClasses} {...props}>
      {text}
    </button>
  )
}

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  theme: PropTypes.oneOf(['reversed', '']),
  size: PropTypes.oneOf(['small', 'default']),
  text: PropTypes.string.isRequired,
  asAnchor: PropTypes.bool.isRequired,
}

